import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Auth from '@okta/okta-vue'

const AuthConfig = {
  issuer: (window).envConfig && (window).envConfig.OKTA_ISSUER ? (window).envConfig.OKTA_ISSUER : 'https://jllpoc.oktapreview.com/oauth2/default',
  client_id: (window).envConfig && (window).envConfig.OKTA_CLIENT_ID ? (window).envConfig.OKTA_CLIENT_ID : '0oaiaoqu1yvNNH0M70h7',
  redirect_uri: (window).envConfig && (window).envConfig.OKTA_REDIRECT_URI ? (window).envConfig.OKTA_REDIRECT_URI : 'http://localhost:8080/implicit/callback',
  scope: 'openid profile email'
}
// console.log('envConfig', (window).envConfig)
Vue.use(Auth, AuthConfig)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/analyzer',
      name: 'networkAnalyzer',
      meta: {
        requiresAuth: true
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/NetworkAnalyzer.vue')
    },
    {
      path: '/calculator',
      name: 'costCalculator',
      meta: {
        requiresAuth: true
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/FacilityCostCalculator.vue')
    },
    {
      path: '/session-usage-data-exporter',
      name: 'sessionUsageDataExporter',
      meta: {
        requiresAuth: true
      },
      component: () => import('./views/SessionUsageDataExporter.vue')
    },
    {
      path: '/implicit/callback',
      component: Auth.handleCallback()
    },
  ]
})
